export default __webpack_public_path__ + "static/europaLeagueFlag-318e4afcc1a9ec480fc3ffa79a9af743.svg";